import StudentList from './StudentList';

export default StudentList; 